<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Mechanical Engineering</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Doctorate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time text-nowrap">Bachelor of Technology (Mechanical Engineering)</td>
                            <td class="time text-nowrap">Master of Technology (Mechanical Engineering)</td>
                            <td class="time text-nowrap">Ph.D Mechanical</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Mechanical Engineering</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Technology (Mechanical Engineering) </b>
                    – The B.Tech in Mechanical Engineering program at
                    ARNI School of Technology is designed to equip students with a strong foundation in mechanical
                    principles, engineering design, thermal sciences, and manufacturing technologies. There are eight
                    semesters in this four-year degree program.

                </p>
            </div>
            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Foundation</p>
                <ul>
                    <li>Engineering Mathematics-I</li>
                    <li>Engineering Physics-I</li>
                    <li>Engineering Mechanics</li>
                    <li>Basic Electrical and Electronics Engineering</li>
                    <li>Engineering Graphics</li>
                    <li>Engineering Chemistry</li>
                    <li>HASS Elective - I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II </b>: Fundamentals of Engineering
                </p>
                <ul>
                    <li>Engineering Mathematics-II</li>
                    <li>Engineering Physics-II</li>
                    <li>Principles of Electrical Engineering</li>
                    <li>English for Communication</li>
                    <li>Introduction to Computer Programming</li>
                    <li>Workshop Technology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III </b>: Core Mechanical Engineering
                    Concepts
                </p>
                <ul>
                    <li>Engineering Mathematics-II</li>
                    <li>Engineering Physics-II</li>
                    <li>Principles of Electrical Engineering</li>
                    <li>English for Communication</li>
                    <li>Introduction to Computer Programming</li>
                    <li>Workshop Technology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV</b>: Advanced Mechanical Systems
                </p>
                <ul>
                    <li>Fluid Mechanics</li>
                    <li>Kinematics of Machines</li>
                    <li>Aerospace Structural Mechanics</li>
                    <li>Energy Conversion Systems</li>
                    <li>Numerical Methods</li>
                    <li>Program Elective – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V</b>: Specialized Studies and Applications
                </p>
                <ul>
                    <li>Machine Design-I</li>
                    <li>Manufacturing Science</li>
                    <li>Engineering and Managerial Economics</li>
                    <li>Flight Dynamics I</li>
                    <li>Heat and Mass Transfer</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI</b>: Industry-Aligned Learning
                </p>
                <ul>
                    <li>Machine Design-II</li>
                    <li>Refrigeration & Air conditioning</li>
                    <li>Principles of Industrial Engineering</li>
                    <li>Flight Dynamics II</li>
                    <li>Machine Tools & Machining</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VII</b>: Research and Innovation
                </p>
                <ul>
                    <li>Computer-Aided Design
                    </li>
                    <li>Design Elective
                    </li>
                    <li>Life sciences</li>
                    <li>Humanities I
                    </li>
                    <li>Industrial/Practical Training</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VIII
                </b>: Capstone Project & Career Readiness
                </p>
                <ul>
                    <li> Advanced Manufacturing Processes
                    </li>
                    <li>Design Elective
                    </li>
                    <li>Humanities II
                    </li>
                    <li>Major Project
                    </li>
                    <li> Seminar and Viva Voce
                    </li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Technology (Mechanical Engineering) </b> –
                    The
                    M.Tech in Mechanical Engineering program at ARNI School of Technology is designed to equip students
                    with advanced knowledge and skills to deepen their understanding related to mechanical technologies,
                    research and development. There are four semesters in this two-year degree program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I
                </b>: Foundational and Advanced Concepts
                </p>
                <ul>
                    <li> Advanced Engg. Math
                    </li>
                    <li>Numerical Analysis and Optimization
                    </li>
                    <li>Mechatronics and Product Design
                    </li>
                    <li>Experimental Stress Analysis
                    </li>
                    <li> Advanced Fluid Mechanics
                    </li>
                    <li>Elective I
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Specialized Studies
                </p>
                <ul>
                    <li> Advanced Heat Transfer
                    </li>
                    <li>Theory of Elasticity
                    </li>
                    <li>Vibration and Condition Monitoring
                    </li>
                    <li>CAD/CAM Lab
                    </li>
                    <li> Elective II
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: Research and Applications
                </p>
                <ul>
                    <li> Materials Behaviour and Vibration Lab
                    </li>
                    <li>Robotics & Mechatronics Lab
                    </li>
                    <li>Seminar I
                    </li>
                    <li>Dissertation Phase-I
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Advanced Core
                </p>
                <ul>
                    <li>Seminar II
                    </li>
                    <li>Dissertation Phase-II
                    </li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Ph.D Mechanical </b> – The ARNI School of
                    Technology's
                    Ph.D. program in Mechanical Engineering is intended for students who are enthusiastic about
                    cutting-edge mechanical engineering research and innovation. The curriculum equips enthusiastic
                    individuals with comprehensive skills and information that may support industrial development,
                    sustainable development, and academic achievement. It lasts for three to six years and is divided
                    into six semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I
                </b>: Coursework
                </p>
                <ul>
                    <li> Communication Skills
                    </li>
                    <li>Research Methodology
                    </li>
                    <li>Philosophical and Sociological Basis of Educational Research
                    </li>
                    <li>Methods of Applied Mathematics
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Practical
                </p>
                <ul>
                    <li> Research Methodology
                    </li>
                    <li>Elective I
                    </li>
                    <li>Metal Cutting and Removal Process
                    </li>
                    <li>Seminar and Research
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: Specializations
                </p>
                <ul>
                    <li> Finite Element Analysis
                    </li>
                    <li> Research Methodology I
                    </li>
                    <li>Elective II
                    </li>
                    <li> Seminar
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Research and Development
                </p>
                <ul>
                    <li> Automatic Regulating Systems
                    </li>
                    <li> Research Methodology I
                    </li>
                    <li> Elective II
                    </li>
                    <li> Seminar
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V
                </b>: Research and Dissertation
                </p>
                <ul>
                    <li> Research Project
                    </li>
                    <li> Thesis
                    </li>
                    <li> Seminar
                    </li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI
                </b>: Research and Dissertation
                </p>
                <ul>
                    <li> Research Project
                    </li>
                    <li>Thesis
                    </li>
                    <li> Seminar
                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>
